// Agent Configuration Constants

// Agent types
export const AGENT_TYPES = {
  SKRIPSI: 'skripsi_agent',
  ARTIKEL: 'artikel_agent',
  MAKALAH: 'makalah_agent',
  GAMBAR: 'gambar_agent',
  VIDEO: 'video_agent',
  BUKU: 'buku_agent',
  NOVEL: 'novel_agent',
  BERITA: 'berita_agent',
  SEARCH: 'search_agent',
  TRENDING: 'trending_agent',
  WRITING: 'writing_agent',
  PPT: 'ppt_agent',
  CHART: 'chart_agent',
  RESEARCH: 'research_agent',
  PDF: 'pdf_agent',
  // Add more agent types here as needed
}

// Model modes for agents (simplified version)
export const MODEL_MODES = {
  STANDARD: 'standard',
  THINKING: 'thinking',
  GENIUS: 'genius',
  CLEVER: 'clever',
  WRITE: 'write'
}

// Default model mode for agents
export const DEFAULT_MODEL_MODE = MODEL_MODES.STANDARD

// Agent-specific configurations
export const AGENT_CONFIG = {
  // Default settings for all agents
  DEFAULT_MAX_TOKENS: 2000,
  DEFAULT_TEMPERATURE: 0.7,
  
  // Agent-specific settings
  ARTIKEL: {
    maxTokens: 2500,
    temperature: 0.7,
    minWords: 800
  },
  SKRIPSI: {
    maxTokens: 3000,
    temperature: 0.6,
    minWords: 1500
  },
  MAKALAH: {
    maxTokens: 2800,
    temperature: 0.7,
    minWords: 1200
  },
  BERITA: {
    maxTokens: 2200,
    temperature: 0.8,
    minWords: 600
  },
  GAMBAR: {
    maxTokens: 1000,
    temperature: 0.9,
    minWords: 0
  },
  VIDEO: {
    maxTokens: 1000,
    temperature: 0.9,
    minWords: 0,
    credits: 30 // Video Agent consumes 30 credits per generation
  },
  BUKU: {
    maxTokens: 4000,
    temperature: 0.6,
    minWords: 2000,
    credits: 200, // Buku Agent consumes 200 credits per use
    modelMode: 'write' // Uses WRITE model for extended content generation
  },
  SEARCH: {
    maxTokens: 2000,
    temperature: 0.7,
    minWords: 300,
    credits: 5 // Search Agent consumes 5 credits per use
  },
  TRENDING: {
    maxTokens: 0,
    temperature: 0,
    minWords: 0,
    credits: 2,
    useDirectOutput: true
  },
  WRITING: {
    maxTokens: 2000,
    temperature: 0.7,
    minWords: 50,
    credits: 1,
    aiActionCredits: 1
  },
  PPT: {
    maxTokens: 3000,
    temperature: 0.7,
    minWords: 0,
    credits: 20, // Updated to match subscriptionService CREDIT_COSTS
    slideCredits: 1
  },
  CHART: {
    maxTokens: 2500,
    temperature: 0.7,
    minWords: 0,
    credits: 10, // Chart Agent consumes 10 credits per use
    chartCredits: 1 // Each chart regeneration consumes 1 credit
  },
  RESEARCH: {
    maxTokens: 4000,
    temperature: 0.6,
    minWords: 3000,
    credits: 30, // Research Agent consumes 30 credits per use
    researchCredits: 1 // Each research paper generation consumes 1 credit
  },
  PDF: {
    maxTokens: 3000,
    temperature: 0.7,
    minWords: 0,
    credits: 10, // PDF Agent consumes 10 credits per use
    pdfCredits: 1 // Each PDF analysis consumes 1 credit
  },
  NOVEL: {
    maxTokens: 4000,
    temperature: 0.7,
    minWords: 60000, // 250-400 pages target (250 words per page average)
    credits: 200, // Novel Agent consumes 200 credits per use
    modelMode: 'write' // Uses WRITE model for extended content generation
  }
}

// Backward compatibility alias (deprecated - use AGENT_CONFIG instead)
export const BOT_CONFIG = AGENT_CONFIG